import React from "react";
import { ErrorText } from "./CategoryLimitsField.styles";

interface FieldErrorsProps {
  /** Given to the first message, so a control can point to it with `aria-describedby`. */
  id: string;
  messages: readonly string[];
}

export function FieldErrors({ id, messages }: FieldErrorsProps) {
  if (messages.length === 0) {
    return null;
  }
  return (
    <div id={id}>
      {messages.map((message, index) => (
        <ErrorText key={index}>{message}</ErrorText>
      ))}
    </div>
  );
}
